import styles from "./InfoBox.module.css";

const InfoBox = ({ title, value, type }) => {
    return (
        <div
            className={`${styles.InfoBox} ${styles[`InfoBox_${type}`]}`}
            data-testid={`info-box-${title.toLowerCase().replace(/\s/g, "-")}`}
        >
            <h2 className={styles.InfoBoxTitle}>{title}</h2>
            <p className={styles.InfoBoxValue}>{value}</p>
        </div>
    );
};

export default InfoBox;
